/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

const tradePartnerSlice = createSlice({
    name: 'tradePartnerForm',
    initialState: [],
    reducers: {
        /** Assign trade partner list. The payload should always be Array. */
        setTradePartner: (state, action) => {
            return action.payload;
        },
        /** Add single trade partner information. */
        addTradePartner: (state, action) => {
            // Preset and carrier values cannot be saved when trade partner is created.
            const newTradePartner = { ...action.payload, il_preset: [], il_trade_partner_carrier: [] };
            return [newTradePartner, ...state];
        },
        /** Update single trade partner information. */
        updateTradePartner: (state, action) => {
            const { il_trade_partner } = action.payload;
            return state.map((tradePartner) =>
                tradePartner.id === il_trade_partner.id ? il_trade_partner : tradePartner
            );
        },
    },
});

export const { setTradePartner, addTradePartner, updateTradePartner } = tradePartnerSlice.actions;
export default tradePartnerSlice.reducer;
